export default function(){

    const getKeyData = (scope) => {
        let nMoved = scope.data('moved') || 0;
        let viewWidth = scope.width();
        let cardWidth = $('.bark-carousel-item:first', scope).width();
        let nItems = $('.bark-carousel-item', scope).length;
        let nToMoveUncalc = Math.floor(viewWidth / cardWidth);
        let nToMove;
        let moved;

        return {
            nMoved, viewWidth, cardWidth, nItems, nToMoveUncalc, nToMove, moved
        }
    }

    const navigate = (direction, scope) => {
        const $carouselItem = $('.bark-carousel-item', scope);

        if (direction !== 'none') {
            $carouselItem.addClass('on-the-move');
        }

        let nMoved = scope.data('moved') || 0;
        let viewWidth = scope.width();
        let cardWidth = $('.bark-carousel-item:first', scope).width();
        let nItems = $('.bark-carousel-item', scope).length;
        let nToMoveUncalc = Math.floor(viewWidth / cardWidth);
        let nToMove;
        let moved;

        if (direction === 'left') {
            nToMove = Math.min(nToMoveUncalc, nMoved);
            moved = nMoved - nToMove;
            if (moved < 0) {
                moved = 0;
            }
        } else if (direction === 'right') {
            nToMove = Math.min(nToMoveUncalc, nItems - nToMoveUncalc - nMoved);
            moved = nMoved + nToMove;
        } else if (direction === 'none') {
            nToMove = 0;
            moved = Math.min(nMoved + nToMove, nItems - nToMoveUncalc);
        } else {
            return false;
        }

        scope.data({moved});

        $carouselItem.css({transform: `translateX(-${(moved * 100)}%)`});

        $('.next-page', scope)[(moved >= (nItems - nToMoveUncalc)) || moved < 0 ? 'addClass' : 'removeClass']('disabled');
        $('.previous-page', scope)[moved < 1 ? 'addClass' : 'removeClass']('disabled');

        // Hide the controls if not enough cards to paginate
        $('.page-buttons', scope)[nItems <= nToMoveUncalc ? 'addClass' : 'removeClass']('hidden');
    }

    const bindListeners = () => {
        $('.bark-carousel .previous-page').off('click.navigate').on('click.navigate', function () {
            let t = $(this);

            if (!t.hasClass('disabled')) {
                navigate('left', t.closest('.bark-carousel'));
            }
        });

        $('.bark-carousel .next-page').off('click.navigate').on('click.navigate', function () {
            let t = $(this);

            if (!t.hasClass('disabled')) {
                navigate('right', t.closest('.bark-carousel'));
            }
        });

        $(window).off('resizeEnd.paginationArrows').on('resizeEnd.paginationArrows', function () {
            $('.bark-carousel').each(function () {
                navigate('none', $(this));
            });
        });

        $('.bark-carousel-item').on('transitionend', function(e) {
            $('.bark-carousel-item').removeClass('on-the-move');
        })
    }

    const init = (selector) => {
        bindListeners();
        navigate('none', selector);
    }

    return {
        init,
        bindListeners,
        navigate,
        getKeyData
    }
}
